<template lang="pug">
  .component-reservation-list.row.column
    reservation-list-form(@filterReservations="setSearch", @searchReservations="setSearch")
    //p(v-if = "timeFromSearch").text-center Data Report Range {{ timeFromSearch }} - {{ timeToSearch }}
    //cards(v-if="$acl('reservations-reports')" :data="parsedReports")
    base-list(:component="component", :dataLoader="dataLoader", :search="search", :searchRangeDataLoader="getReports", ref="list")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import ReservationListForm from 'components/structure/ui/filters/ReservationListForm'
import BaseList from './BaseList'
import HeaderColumns from 'components/structure/ui/HeaderColumns'
import Cards from '../../components/structure/Cards'
import {mapState} from 'vuex'

export default {
  name: 'ReservationList',
  components: {
    Cards,
    HeaderColumns,
    ReservationListForm,
    BaseList
  },
  data() {
    return {
      component: require('components/backoffice/Reservation'),
      headers: ['', 'Reservation', 'Vehicle', 'Start', 'End', 'B.mode', 'Distance', 'Time', 'Cost', 'Status'],
      search: null,
      reports: null,
      timeToSearch: null,
      timeFromSearch: null
    }
  },
  methods: {
    setSearch(search) {
      this.search = search
      this.$refs.list.debouncedLoader()
    },
    dataLoader(callback, page, resultsPerPage, search) {
      if (search && search.query) {
        KeplerBackofficeSdk.reservations.list(page, resultsPerPage, search).search((data) => {
          callback(data)
        })
        return
      }
      KeplerBackofficeSdk.reservations.list(page, resultsPerPage, search).all((data) => {
        callback(data)
      })
    },
    getReports(range) {
      this.reports = null
      if (this.$acl('reservations-reports')) {
        KeplerBackofficeSdk.reports.list(range).reservations((data) => {
          this.reports = data
        })
        this.timeFromSearch = range.start
        this.timeToSearch = range.end
      }
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    parsedReports: function () {
      if (!this.reports) {
        return []
      }

      return [
        {
          title: 'Average distance',
          value: this.reports.average_km + `${this.configuration.locale.locale_distance_unit.value}`
        },
        {
          title: 'Tot. Reserv.',
          value: this.reports.reservation_count
        },
        {
          title: 'Booked hours',
          value: this.reports.total_booked_hours
        },
        {
          title: 'Driven distance',
          value: this.reports.total_driven_km + `${this.configuration.locale.locale_distance_unit.value}`
        },
      ]
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ReservationList.vue?5896f27e